import { useMutation } from '@tanstack/react-query';
import { dashboardMainService } from 'v2/services/dashboardMain';

export const useClickNewzz = () => {
  const mutation = useMutation({
    mutationFn: (id: number) => dashboardMainService.clickNewzz(id)
  });

  return { clickNewzz: mutation.mutate, isLoading: mutation.isPending, error: mutation.error };
};
